export default __webpack_public_path__ + "static/Mask group-52f26ef8c7a1af3ca2888e4108c4e3a0.png";